import { render, staticRenderFns } from "./AddItemDetails.vue?vue&type=template&id=13be2050&"
import script from "./AddItemDetails.vue?vue&type=script&lang=ts&"
export * from "./AddItemDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports